import { observable, action, runInAction } from 'mobx'
import commonApi from '@api/zhi_shui/commonApi'
import Api from '@api/shou_xie/storeManage'
import { message } from 'hljd'
import { logout } from '@util'

class Store {
  @observable form = {}

  @observable front = ''
  @action
  uploadFront = type => (file, link) => {
    this[type] = link
  }

  @action
  removeFront = type => () => {
    this[type] = ''
  }

  @observable back = ''
  @action
  uploadBack = type => (file, link) => {
    this[type] = link
  }

  @action
  removeBack = type => () => {
    this[type] = ''
  }
  @observable logo_path = ''
  @action
  uploadLogo = type => (file, link) => {
    this[type] = link
  }

  @action
  removeLogo = type => () => {
    this[type] = ''
  }
  @observable company_license = ''
  @action
  uploadCompany_license = type => (file, link) => {
    this[type] = link
  }

  @action
  removeCompany_license = type => () => {
    this[type] = ''
  }

  @observable country = []
  @action
  async getCountry() {
    let { data = [] } = await commonApi.getPCCApi()
    runInAction(() => {
      this.country = data
    })
  }

  @observable town = ''
  @action
  changeTown = value => {
    this.town = value
  }

  getParams() {
    const { front, back, town, company_license } = this
    return {
      ...this.form,
      certify_front: front,
      certify_back: back,
      shop_area_id: town[2],
      company_license
    }
  }

  @action
  doPost = async () => {
    let params = this.getParams()
    let { success } = await Api.edit(params)
    if (success) {
      message.success('操作成功！2秒后跳转登录页面，请重新登录！')
      setTimeout(() => {
        logout()
      }, 2000)
    }
  }

  @action
  getData = async () => {
    let { data } = await Api.get_data()
    runInAction(() => {
      this.form = data
      if (data.shop_area.parent.parent) {
        this.town = [
          data.shop_area.parent.parent.id,
          data.shop_area.parent.id,
          data.shop_area.id
        ]
      } else {
        this.town = [data.shop_area.parent.id, data.shop_area.id] || [
          '',
          '',
          ''
        ]
      }
      this.front = data.certify_front
      this.back = data.certify_back
      this.logo_path = data.logo_path
      this.company_license = data.company_license
    })
  }
}
export default new Store()
